import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice"; // Import your slice
import yojnaIdManagementSlice from "./yojnaIdManagementSlice"

const store = configureStore({
  reducer: {
    auth: authReducer,
    yojnaId: yojnaIdManagementSlice,
  },
});

export default store;
